import React, { useState, useEffect } from "react";
import LogoHeader from "./LogoHeader";
import AlbaranPdfButton from "./AlbaranPdfButton";
import SignatureCanvas from "./SignatureCanvas";
import { AiOutlineQrcode } from "react-icons/ai";
import { MdContentCopy } from "react-icons/md";
import { FiAlertCircle } from "react-icons/fi";
import "../components/AlbaranCreated.css";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Header02 from "./Header02";
import https from "../pluggins/http";
import { Online } from "react-detect-offline";
import { firmarDiContenedor } from "../pluggins/albaranes";
import {
  cajasLabel,
  diContenedorIncompleto,
  duplicarAlbaran,
  servicioLabel,
} from "../services/albaranes";

function AlbaranCreated(props) {
  let history = useHistory();
  const estado = props.location;
  const user = useSelector((state) => state?.auth?.currentUser?.data);
  const [albaran, setAlbaran] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFirmaForm, setShowFirmaForm] = useState(false);
  const [showSignature, setShowSignature] = useState(false);
  const [firmanteNombre, setFirmanteNombre] = useState("");
  const [firmanteDni, setFirmanteDni] = useState("");
  const [emailManual, setEmailManual] = useState("");
  const [isSigning, setIsSigning] = useState(false);

  useEffect(() => {
    const cargarAlbaran = async () => {
      try {
        // Si viene en props.location.albaran, usarlo
        if (props.location?.albaran) {
          // Si solo tiene id, cargar datos completos del backend
          if (
            props.location.albaran.id &&
            (!props.location.albaran.ver_obra || !props.location.albaran.op)
          ) {
            const response = await https.get(
              `getAlbaran/${props.location.albaran.id}`,
            );
            const albaranCompleto = response.data;
            setAlbaran(albaranCompleto);
            sessionStorage.setItem("albaran", JSON.stringify(albaranCompleto));
          } else {
            setAlbaran(props.location.albaran);
            sessionStorage.setItem(
              "albaran",
              JSON.stringify(props.location.albaran),
            );
          }
        } else if (sessionStorage.length > 0) {
          // Intentar recuperar del sessionStorage
          const albaranGuardado = JSON.parse(sessionStorage.getItem("albaran"));
          if (
            albaranGuardado?.id &&
            (!albaranGuardado.ver_obra || !albaranGuardado.op)
          ) {
            const response = await https.get(
              `getAlbaran/${albaranGuardado.id}`,
            );
            const albaranCompleto = response.data;
            setAlbaran(albaranCompleto);
            sessionStorage.setItem("albaran", JSON.stringify(albaranCompleto));
          } else {
            setAlbaran(albaranGuardado);
          }
        }
      } catch (error) {
        console.error("Error cargando albarán:", error);
      } finally {
        setLoading(false);
      }
    };

    cargarAlbaran();
  }, [props.location?.albaran]);

  var isActive = false;

  const handleDuplicar = async () => {
    if (!window.confirm("¿Crear un nuevo DI con los mismos datos?")) return;
    try {
      const nuevo = await duplicarAlbaran(albaran.id);
      if (nuevo) {
        alert("DI duplicado correctamente.");
        history.push({ pathname: "/albaranCreated", albaran: nuevo });
      }
    } catch {
      alert("Error al duplicar el DI. Inténtalo de nuevo.");
    }
  };

  const delAlbaran = async () => {
    if (!window.confirm("¿Estás seguro que quieres eliminar el DI?")) return;
    try {
      const response = await https.post("delAlbaran", {
        id: albaran.id,
      });
      if (response.data?.data) {
        alert("El albarán se eliminó correctamente.");
        history.push("/ListScreen");
      }
    } catch {
      alert(
        "Parece que ha habido algún problema. Inténtalo de nuevo en unos segundos.",
      );
    }
  };

  const abrirSolicitudFirma = () => {
    if (albaran?.firma_cliente) {
      if (
        !window.confirm(
          "Este DI ya tiene firma del cliente. ¿Quieres sustituirla?",
        )
      ) {
        return;
      }
    }
    setFirmanteNombre(albaran?.firmante_nombre || "");
    setFirmanteDni(albaran?.firmante_dni || "");
    setEmailManual("");
    setShowFirmaForm(true);
    setShowSignature(false);
  };

  const emailClienteAlbaran = (a) =>
    a?.ver_obra?.cliente?.email ||
    a?.verObra?.cliente?.email ||
    "";

  const handleSignatureSubmit = async (firmaBase64) => {
    if (!user?.id || !albaran?.id) return;
    setIsSigning(true);
    try {
      const emailCliente = emailClienteAlbaran(albaran);
      const response = await firmarDiContenedor(albaran.id, {
        conductor_id: user.id,
        firma: firmaBase64,
        firmante_nombre: firmanteNombre.trim(),
        firmante_dni: firmanteDni.trim(),
        cliente_email_override: emailCliente || emailManual.trim() || null,
      });
      const datos = response.data?.data || {};
      const actualizado = {
        ...albaran,
        firma_cliente: datos.firma_cliente || firmaBase64,
        firmante_nombre: datos.firmante_nombre || firmanteNombre.trim(),
        firmante_dni: datos.firmante_dni || firmanteDni.trim(),
        hora_firma_cliente: datos.hora_firma_cliente,
        filename: datos.filename || albaran.filename,
      };
      setAlbaran(actualizado);
      sessionStorage.setItem("albaran", JSON.stringify(actualizado));
      setShowSignature(false);
      setShowFirmaForm(false);
      alert("Firma del cliente guardada correctamente");
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Error al guardar la firma. Inténtalo de nuevo.",
      );
    } finally {
      setIsSigning(false);
    }
  };

  const estadoImage = (estado) => {
    if (estado === "active") {
      isActive = true;
      return (
        <img
          className="estadoImage"
          src={require("../assets/images/play.png")}
        />
      );
    } else if (estado === "approved") {
      return (
        <img
          className="estadoImage"
          src={require("../assets/images/tick.png")}
        />
      );
    } else if (estado === "denied") {
      return (
        <img
          className="estadoImage"
          src={require("../assets/images/xv3.png")}
        />
      );
    }
  };

  if (loading) {
    return (
      <div>
        <LogoHeader />
        <div className="containerAlbaran">
          <div className="subContainerWhiteAlbaran">
            <p>Cargando albarán...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!albaran) {
    return (
      <div>
        <LogoHeader />
        <div className="containerAlbaran">
          <div className="subContainerWhiteAlbaran">
            <p>Error: No se pudo cargar el albarán</p>
            <button onClick={() => history.push("/ListScreen")}>
              Volver a la lista
            </button>
          </div>
        </div>
      </div>
    );
  }

  const fecha = new Date(albaran.created_at);
  const fechaNueva = fecha.toLocaleTimeString("es-ES");
  const incompleto = diContenedorIncompleto(albaran);
  const esContenedor = albaran?.tipo === "contenedor";
  const puedeFirmarCliente =
    esContenedor &&
    (albaran?.estado === "active" || albaran?.estado === "scanned") &&
    !incompleto;

  // Función para formatear fecha de YYYY-MM-DD a DD/MM/YYYY
  const formatFecha = (fecha) => {
    if (!fecha) return "-";
    const parts = fecha.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return fecha;
  };

  if (showFirmaForm && !showSignature) {
    const emailCliente = emailClienteAlbaran(albaran);
    const needsEmail = !emailCliente;
    const canProceed =
      firmanteNombre.trim() &&
      firmanteDni.trim() &&
      (!needsEmail || emailManual.trim());
    return (
      <div>
        <LogoHeader />
        <div className="containerAlbaran">
          <div className="subContainerWhiteAlbaran">
            <div className="firma-cliente-panel">
              <h3>Datos del firmante (cliente)</h3>
              <p className="firma-cliente-hint">
                Pasa el dispositivo a alguien del cliente para que complete sus
                datos y firme. Se enviará una copia del DI por email.
              </p>
              <div className="firma-form">
                <label>Nombre completo del firmante *</label>
                <input
                  type="text"
                  value={firmanteNombre}
                  onChange={(e) => setFirmanteNombre(e.target.value)}
                  placeholder="Nombre y apellidos"
                  autoComplete="name"
                />
                <label>DNI del firmante *</label>
                <input
                  type="text"
                  value={firmanteDni}
                  onChange={(e) => setFirmanteDni(e.target.value)}
                  placeholder="DNI / NIE"
                  autoComplete="off"
                />
                {emailCliente ? (
                  <p className="firma-email-info">
                    Se enviará confirmación a:{" "}
                    <strong>{emailCliente}</strong>
                  </p>
                ) : (
                  <>
                    <label>Email del cliente *</label>
                    <input
                      type="email"
                      value={emailManual}
                      onChange={(e) => setEmailManual(e.target.value)}
                      placeholder="email@ejemplo.com"
                      autoComplete="email"
                    />
                  </>
                )}
                <button
                  type="button"
                  className="btnAlbaran BtnFirmaCliente"
                  disabled={!canProceed}
                  onClick={() => setShowSignature(true)}
                >
                  Continuar a firma
                </button>
                <button
                  type="button"
                  className="btn-cancel-firma"
                  onClick={() => setShowFirmaForm(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showSignature) {
    return (
      <div>
        <LogoHeader />
        <div className="containerAlbaran">
          <div className="subContainerWhiteAlbaran">
            <div className="firma-cliente-panel">
              {isSigning ? (
                <p>Guardando firma…</p>
              ) : (
                <SignatureCanvas
                  title="Firma del cliente"
                  signLabel="Confirmar firma"
                  onSign={handleSignatureSubmit}
                  onCancel={() => setShowSignature(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>{estado === "Done" ? <LogoHeader /> : <Header02 />}</div>
      <div className="containerAlbaran">
        <div className="subContainerWhiteAlbaran">
          <div className="subContainerAlbaran spaceBetwwenAlbaran">
            <div className="spacingAlbaran">
              <p>
                <strong>
                  {albaran?.ref || "-"} - {estadoImage(albaran?.estado)}
                  {incompleto && (
                    <FiAlertCircle
                      title="Faltan datos"
                      style={{ marginLeft: 8, color: "#d97706", verticalAlign: "middle" }}
                    />
                  )}
                </strong>
              </p>
            </div>
          </div>
          {incompleto && albaran?.estado === "active" && (
            <div className="subContainerAlbaran borderBottomContainer">
              <div className="spacingAlbaran" style={{ width: "100%" }}>
                <p style={{ color: "#92400e", marginBottom: 8 }}>
                  Faltan datos (residuo, destino u otros) para generar el PDF.
                </p>
                <Link
                  to={{
                    pathname: "/DetallesContenedor",
                    albaran: albaran,
                  }}
                >
                  <button type="button" className="btnAlbaran BtnQRAlbaran">
                    Completar datos
                  </button>
                </Link>
              </div>
            </div>
          )}
          <div className="subContainerAlbaran borderBottomContainer">
            <div className="spacingAlbaran">
              <p>
                <strong>Empresa Operadora</strong>
              </p>
              <p>
                {albaran?.verObra?.op?.nombre ||
                  albaran?.ver_obra?.op?.nombre ||
                  "-"}
              </p>
            </div>
            <div className="spacingAlbaran">
              <p>
                <strong>Empresa Transportista</strong>
              </p>
              <p>
                {albaran?.get_conductor?.transportista?.nombre ||
                  albaran?.getConductor?.transportista?.nombre ||
                  albaran?.get_conductor?.op?.nombre ||
                  albaran?.getConductor?.op?.nombre ||
                  albaran?.op?.nombre ||
                  "-"}
              </p>
            </div>
          </div>
          <div className="subContainerAlbaran borderBottomContainer">
            <div className="spacingAlbaran">
              <p>
                <strong>{albaran?.tipo === "contenedor" ? "Dirección" : "Obra"}</strong>
              </p>
              <p>
                {albaran?.verObra?.nombre || albaran?.ver_obra?.nombre || "-"}
              </p>
            </div>
            {albaran?.tipo === "contenedor" && (
              <div className="spacingAlbaran">
                <p>
                  <strong>Servicio</strong>
                </p>
                <p>
                  {servicioLabel(albaran?.tipo_servicio)} · {albaran?.capacidad_m3} m
                  <sup>3</sup>
                </p>
              </div>
            )}
            {albaran?.tipo === "contenedor" && (
              <div className="spacingAlbaran">
                <p>
                  <strong>Nº caja</strong>
                </p>
                <p>{cajasLabel(albaran)}</p>
              </div>
            )}
          </div>
          <div className="subContainerAlbaran borderBottomContainer">
            <div className="spacingAlbaran">
              <p>
                <strong>Destino</strong>
              </p>
              <p>{albaran?.verts?.nombre || "-"}</p>
            </div>
            <div>
              <p>
                <strong>Tipo de Residuo</strong>
              </p>
              <p>
                {albaran?.residuo?.nombre || "-"} - CÓDIGO LER:{" "}
                {albaran?.residuo?.codigo_ler || "-"}
              </p>
            </div>
          </div>
          <div className="subContainerAlbaran borderBottomContainer flexAlbaran">
            <div className="spacingAlbaran">
              <p>
                <strong>
                  M<sup>3</sup>
                </strong>
              </p>
              <p>
                {albaran?.m3_Kg || "-"} m<sup>3</sup>
              </p>
            </div>
            {albaran?.peso && (
              <div className="spacingAlbaran">
                <p>
                  <strong>Peso</strong>
                </p>
                <p>{albaran?.peso || "-"} kg</p>
              </div>
            )}
            <div className="spacingAlbaran">
              <p>
                <strong>Fecha</strong>
              </p>
              <p>{formatFecha(albaran?.fecha)}</p>
            </div>
            <div className="spacingAlbaran">
              <p>
                <strong>Hora</strong>
              </p>
              <p>{fechaNueva}</p>
            </div>
          </div>
          <div className="subContainerAlbaran borderBottomContainer flexAlbaran">
            <div className="spacingAlbaran">
              <p>
                <strong>Fecha de validación</strong>
              </p>
              <p>{albaran?.hora_vertido || "-"}</p>
            </div>
          </div>
          <div className="subContainerAlbaran borderBottomContainer">
            <div className="spacingAlbaran">
              <p>
                <strong className="txtBoldAlbaran">Conductor</strong>
              </p>
              <p>
                {albaran?.get_conductor?.nombre ||
                  albaran?.getConductor?.nombre ||
                  "-"}
              </p>
              <p>
                <strong>DNI</strong>
              </p>
              <p>
                {albaran?.get_conductor?.dni ||
                  albaran?.getConductor?.dni ||
                  "-"}
              </p>
            </div>
            <div>
              <p>
                <strong>Matricula</strong>
              </p>
              <p>{albaran?.camion || "-"}</p>
            </div>
          </div>
          <div className="subContainerAlbaran">
            <div className="spacingAlbaran">
              <p>
                <strong>Comentarios</strong>
              </p>
              <p>{albaran?.comentarios || "-"}</p>
            </div>
          </div>
          <div className="subContainerAlbaran">
            <div className="spacingAlbaran">
              <p>
                <strong>Comentarios de Vertedero</strong>
              </p>
              <p>{albaran?.comentarios_vertedero || "-"}</p>
            </div>
          </div>
          {esContenedor && (
            <div className="subContainerAlbaran borderBottomContainer">
              <div className="spacingAlbaran" style={{ width: "100%" }}>
                <p>
                  <strong>Firma del cliente</strong>
                </p>
                {albaran?.firma_cliente ? (
                  <>
                    <p>
                      Firmado por {albaran.firmante_nombre || "cliente"}
                      {albaran.firmante_dni ? ` (${albaran.firmante_dni})` : ""}
                      {albaran.hora_firma_cliente
                        ? ` · ${albaran.hora_firma_cliente}`
                        : ""}
                    </p>
                    <img
                      className="firma-cliente-preview"
                      src={albaran.firma_cliente}
                      alt="Firma del cliente"
                    />
                  </>
                ) : (
                  <p>Pendiente de firma</p>
                )}
              </div>
            </div>
          )}
          {albaran?.estado === "active" || albaran?.estado === "scanned" ? (
            <>
              <div className="subContainerAlbaran spaceArroundAlbaran">
                <div className="btnAlbaranContainer">
                  {!incompleto && <AlbaranPdfButton albaran={albaran} />}
                  {!incompleto && (
                    <Link
                      to={{
                        pathname: "/QR",
                        id: albaran.id,
                      }}
                    >
                      <button type="submit" className="btnAlbaran BtnQRAlbaran">
                        <AiOutlineQrcode id="qrCodeAlbaran" />
                        Generar QR
                      </button>
                    </Link>
                  )}
                  {puedeFirmarCliente && (
                    <Online>
                      <button
                        type="button"
                        className="btnAlbaran BtnFirmaCliente"
                        onClick={abrirSolicitudFirma}
                      >
                        {albaran?.firma_cliente
                          ? "Volver a firmar"
                          : "Solicitar firma al cliente"}
                      </button>
                    </Online>
                  )}
                  <Online>
                    <button
                      type="button"
                      className="btnAlbaran BtnDuplicarAlbaran"
                      onClick={handleDuplicar}
                    >
                      <MdContentCopy id="duplicarAlbaranIcon" />
                      Duplicar DI
                    </button>
                  </Online>
                </div>
              </div>
              <Online>
                <div className="subContainerAlbaran spaceArroundAlbaran">
                  <div className="btnAlbaranContainer">
                    <div>
                      <p onClick={delAlbaran} className="btnEliminarAlbaran">
                        Eliminar
                      </p>
                    </div>
                  </div>
                </div>
              </Online>
            </>
          ) : (
            <div className="subContainerAlbaran spaceArroundAlbaran">
              <div className="btnAlbaranContainer">
                {!incompleto && <AlbaranPdfButton albaran={albaran} />}
                <Online>
                  <button
                    type="button"
                    className="btnAlbaran BtnDuplicarAlbaran"
                    onClick={handleDuplicar}
                  >
                    <MdContentCopy id="duplicarAlbaranIcon" />
                    Duplicar DI
                  </button>
                </Online>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AlbaranCreated;
